import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth'

const REACT_APP_FIREBASE_CONFIG = {
    apiKey: "AIzaSyAUlqVFqNfKTY34UCA0_jt9kHlTqMgDzi0",
    authDomain: "ar-classroom-1bb48.firebaseapp.com",
    projectId: "ar-classroom-1bb48",
    storageBucket: "ar-classroom-1bb48.appspot.com",
    messagingSenderId: "801778279327",
    appId: "1:801778279327:web:e63f67b115057a5e2c53aa",
    measurementId: "G-DEC44C4SPG"
};

//const FIREBASE_CONFIG = REACT_APP_FIREBASE_CONFIG;


class BaseStore {
  constructor(props) {
    // workaround to prevent initializing multiple times
    if(firebase.apps !== undefined){
      if (!firebase.apps.length) {
        firebase.initializeApp(REACT_APP_FIREBASE_CONFIG);
        // firebase.firestore.setLogLevel('debug');
      }
    }
    

    this.firestore = firebase.firestore();
    this.auth = firebase.auth();
  }
}

export default BaseStore;
